/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_Nothreads1Inputs */

const zh_featured_nothreads1 = /** @type {(inputs: Featured_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无精选对话`)
};

const en_featured_nothreads1 = /** @type {(inputs: Featured_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No featured conversations`)
};

const es_featured_nothreads1 = /** @type {(inputs: Featured_Nothreads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conversaciones destacadas`)
};

/**
* | output |
* | --- |
* | "No featured conversations" |
*
* @param {Featured_Nothreads1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const featured_nothreads1 = /** @type {((inputs?: Featured_Nothreads1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_Nothreads1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_nothreads1(inputs)
	if (locale === "en") return en_featured_nothreads1(inputs)
	return es_featured_nothreads1(inputs)
});
export { featured_nothreads1 as "featured_noThreads" }